'use strict';

exports.__esModule = true;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _Rule = require('../Rule');

var _Rule2 = _interopRequireDefault(_Rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isRule = function isRule(obj) {
  return (0, _isObject2.default)(obj) && obj instanceof _Rule2.default;
};

exports.default = isRule;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/utils/isRule.js
// module id = dW+6
// module chunks = 0